import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-builder-validation-messages',
  templateUrl: './builder-validation-messages.component.html'
})
export class BuilderValidationMessagesComponent {

  /**
   * The summary to display when having validation messages and display is triggered
   */
  @Input() validationSummary!: any;
  /**
   * Whether validations should be Displayed
   */
  @Input() displayValidations: boolean = false;

  constructor(private translateService: TranslateService){

  }

  public getTranslatedError(error: any) {
    return this.translateService.instant('Error.ValidationErrorMessage.' + error.code, { ClarificationName: this.translateClarificationName(error.clarificationName) })
  }

  private translateClarificationName(clarificationName: string) {
    if (clarificationName?.toLocaleLowerCase().startsWith("sendgroup")) {
      let sendGroupStringArray = clarificationName.split(" ");
      if(sendGroupStringArray.length > 1){
        return this.translateService.instant('Request.Send.' + sendGroupStringArray[0], { number: sendGroupStringArray[1] });
      } else {
        return this.translateService.instant('Request.Send._' + sendGroupStringArray[0]);
      }
    }
    return clarificationName;
  }
}